module.exports = __webpack_public_path__ + "static/flux-task-analysis-1685dcea44f9ada87d60c015446e979b.jpg";